

























































































































































import { Component, Vue } from "vue-property-decorator";
import DashboardTemplate from "@/views/Layouts/dashboard-template.vue";
import QrcodeVue from "qrcode.vue";
import { ActionTypes } from "@/store/recovery-agent/actions";
import List from "@/components/list.vue";
import RecoveryAgent from "@/models/recoveryAgent.model";
import DemoUserService from "@/services/demo-user.service";

@Component({
  components: {
    DashboardTemplate,
    QrcodeVue,
    List
  },
})
export default class RecoveryApp extends Vue {
  private demoUsers: string[] = [];
  private AddExistingUserToRecoveryAgent = false;
  private dialogFormVisible = false;
  private form: {
    firstName: string,
    lastName: string,
    email: string,
    phone: string,
    platform: "" | "IOS" | "ANDROID",
    password: string,
    checkPass: string
  } = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    platform: "",
    password: "",
    checkPass: ""
  };

  private newUserRules = {
    firstName: [
      { required: true, message: "Please enter a firstname", trigger: "blur" }
    ],
    lastName: [
      { required: true, message: "Please enter a lastname", trigger: "blur" }
    ],
    phone: [
      { required: true, message: "Please enter a phone number", trigger: "blur" }
    ],
    email: [
      { required: true, message: "Please enter an email", trigger: "blur" }
    ],
    platform: [
      { required: true, message: "Please choose a platform", trigger: "blur" }
    ],
    password: [
      { validator: this.validatePass, trigger: "blur" },
    ],
    checkPass: [
      { validator: this.validatePass2, trigger: "blur" }
    ],
  };
  private existingUserRules = {
    firstName: [
      { required: true, message: "Please enter a firstname", trigger: "blur" }
    ],
    lastName: [
      { required: true, message: "Please enter a lastname", trigger: "blur" }
    ],
    phone: [
      { required: true, message: "Please enter a phone number", trigger: "blur" }
    ],
    email: [
      { required: true, message: "Please enter an email", trigger: "blur" }
    ],
    platform: [
      { required: true, message: "Please choose a platform", trigger: "blur" }
    ]
  };
  private async mounted() {
    this.demoUsers = await DemoUserService.getAllDemoUser();
  }

  private get androidRecoveryApp() {
    return `https://console.viloc.eu/apps/recovery?X-VilocSubscription=${this.$typedStore.state.device.settings.apiSubscription}`;
  }

  private async deleteAgent(agent: RecoveryAgent) {
    if (confirm(`Are you sure to delete the agent ${agent.firstName} ${agent.lastName} - ${agent.email}`)) {
      if (await this.$typedStore.dispatch(ActionTypes.RemoveAgent, agent.email)) {
        alert(`The recovery agent was successfully deleted.`);
      } else {
        alert("An error occurred. Please try again.");
      }
    }
  }

  private filterDemoUserNotAlreadyAdded() {
    return this.demoUsers.filter((user) => {
      return !this.$typedStore.getters.agents.some((agent) => agent.email === user);
    });
  }

  private openNewAgentDialog() {
    this.form = {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      platform: "",
      password: "",
      checkPass: ""
    };
    this.dialogFormVisible = true;
  }

  private validatePass(rule: any, value: any, callback: any) {
    if (value === "") {
      callback(new Error("Please input the password"));
    } else if (!/(?=^.{8,}$)(?=.*\d)(?=.*[!@#$%^&*]+)(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.exec(value)) {
      callback(new Error("The password length must be at least 8, contain contain uppercase and lowercase characters, numbers and symbols."));
    } else {
      if (this.form.checkPass !== "") {
        (this.$refs.form as any).validateField("checkPass");
      }
      callback();
    }
  }

  private validatePass2(rule: any, value: any, callback: any) {
    if (value === "") {
      callback(new Error("Please input the password again"));
    } else if (value !== this.form.password) {
      callback(new Error("The password does not match"));
    } else {
      callback();
    }
  }

  private onSubmit() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        if (await this.$typedStore.dispatch(ActionTypes.CreateAgent, this.form)) {
          alert("The recovery agent was created successfully.");
          this.dialogFormVisible = false;
        } else {
          alert("An error occurred. Please try again.");
        }
      }
    });
  }
}
